import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxComponent } from '@app/framework/inputs/checkbox/checkbox.component';

@Component({
  selector: 'app-checklist-item',
  imports: [CommonModule, FormsModule, CheckboxComponent],
  templateUrl: './checklist-item.component.html',
  styleUrls: ['./checklist-item.component.scss'],
})
export class ChecklistItemComponent {
  @Input() checked: boolean;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() disabled = false;
}
